module.exports = __webpack_public_path__ + "img/partner_img17.1ee04faf.png";